import {useEffect, useContext, useState} from 'react';
import {
  StripeAssistantWidgetHeader,
  useWidget,
  useWidgetVisibility,
} from '@stripe-internal/conversations-ui';
import {ConfigContext} from '../Providers/ConfigProvider';

export function HeaderNext() {
  const widget = useWidget();
  const {entrypoint} = useContext(ConfigContext);
  const [supportCenterHref, setSupportCenterHref] = useState<string>('');
  const {visibility: widgetVisibility} = useWidgetVisibility();

  useEffect(() => {
    if (entrypoint === 'dashboard' && widgetVisibility === 'open') {
      widget
        .requestAction(
          {name: 'get-support-center-href'},
          {waitForResponse: true},
        )
        .then((res) => {
          if (res.data) {
            const data = res.data as {href: string};
            setSupportCenterHref(data.href);
          }
        });
    }
  }, [entrypoint, widget, widgetVisibility]);

  return (
    <StripeAssistantWidgetHeader
      supportCenterHref={supportCenterHref}
      entryPoint={entrypoint}
    />
  );
}
